import React from 'react';

import { I18nResource, UserLanguage } from '../types';
import { addResource, setLocale, getSystemLocale } from './i18n';
import sharedResource from './resource.json';
import appDynamicResource from './appDynamic.json';

interface Props {
  children: React.ReactChild;
  staticResource: I18nResource | I18nResource[];
  language: UserLanguage,
  resourcePath?: string,
}

class I18nWrapper extends React.Component<Props> {
  static defaultProps = {
    staticResource: {},
    language: null,
    resourcePath: '',
  };

  constructor(props: Props) {
    super(props);

    if (Array.isArray(props.staticResource)) {
      props.staticResource.forEach(addResource);
    } else {
      addResource(props.staticResource);
    }
    addResource(sharedResource);
    addResource(appDynamicResource);

    // set system wide locale (before user login / authentication)
    setLocale(props.language || getSystemLocale());
  }

  render() {
    return this.props.children;
  }
}

export { I18nWrapper };
